<div class="modal-inner">
    <div class="stepper">
        <div
            [class.active]="activeStep === STEPS.LOCATION"
            [class.filled]="activeStep !== STEPS.LOCATION"
            (click)="setActiveStep(STEPS.LOCATION)">
            <small>Locatie</small>

            {{ location?.substring(0, 20) ?? '-' }}
        </div>

        <div
            class="allowed-nofill"
            [class.active]="activeStep === STEPS.ARTICLE"
            [class.filled]="
                activeStep === STEPS.MATERIAL || activeStep === STEPS.OPTIONAL || activeStep === STEPS.AMOUNT
            "
            (click)="setActiveStep(STEPS.ARTICLE)">
            <small>{{ pickerMode === 'bestekpost' ? 'Bestekpost' : 'Markering' }}</small>

            @if (pickerMode === 'bestekpost') {
                {{ articleCrm ? (articleCrm.description ?? articleCrm.crm_article_id ?? '-').substring(0, 20) : '-' }}
            } @else {
                {{ article ? (article.group + ' - ' + article.name).substring(0, 20) : '-' }}
            }
        </div>

        @if (pickerMode === 'markering') {
            <div
                [class.active]="activeStep === STEPS.MATERIAL"
                [class.filled]="activeStep === STEPS.OPTIONAL || activeStep === STEPS.AMOUNT"
                (click)="setActiveStep(STEPS.MATERIAL)">
                <small>Materiaal</small>

                {{ material?.name ?? '-' }}
            </div>

            <div
                [class.active]="activeStep === STEPS.OPTIONAL"
                [class.filled]="activeStep === STEPS.AMOUNT"
                (click)="setActiveStep(STEPS.OPTIONAL)">
                <small>Optioneel</small>

                @if (usedOptionalMaterials.length) {
                    {{ usedOptionalMaterials.length }}
                    {{ usedOptionalMaterials.length > 1 ? 'materialen' : 'materiaal' }}
                } @else {
                    -
                }
            </div>
        }

        <div [class.active]="activeStep === STEPS.AMOUNT" (click)="setActiveStep(STEPS.AMOUNT)">
            <small>Productie</small>
        </div>
    </div>

    @if (activeStep === STEPS.LOCATION) {
        <div class="modal-inner-inner">
            <h1>
                Locatie<br />
                <small> Straat, kruising of plaats waar het materiaal is aangebracht </small>
            </h1>

            <input #stepFocusInput [formControl]="fcLocation" placeholder="Locatie" type="text" matInput />

            <div class="results">
                @if (fcLocation?.value?.length > 0) {
                    <div
                        #locationItem
                        class="result font-weight-bold"
                        [class.highlight]="selectedIndex === 0"
                        (click)="selectLocation(fcLocation.value)">
                        {{ fcLocation.value }}
                    </div>
                }
                @if (locations?.length > 0) {
                    <div class="result text-center">Eerder gebruikte locaties:</div>

                    @for (location of locations; track location; let locationIndex = $index) {
                        <div
                            #locationItem
                            class="result font-weight-bold"
                            [class.highlight]="locationIndex + (fcLocation.value?.length ? 1 : 0) === selectedIndex"
                            (click)="selectLocation(location)">
                            {{ location }}
                        </div>
                    }
                }
            </div>
        </div>
    }

    @if (activeStep === STEPS.ARTICLE) {
        <div class="modal-inner-inner">
            @if (data.customerId) {
                <div class="material-tabs">
                    <button
                        type="button"
                        class="material-tab"
                        [class.active]="pickerMode === 'markering'"
                        (click)="setPickerMode('markering')">
                        Markering
                    </button>
                    <button
                        type="button"
                        class="material-tab"
                        [class.active]="pickerMode === 'bestekpost'"
                        (click)="setPickerMode('bestekpost')">
                        Bestekpost
                    </button>
                </div>
            }

            @if (pickerMode === 'bestekpost') {
                <input #stepFocusInput [formControl]="fcCrmSearch" placeholder="Zoeken in bestekposten" />

                <div class="results">
                    @if (searching) {
                        <div class="result text-center">aan het zoeken...</div>
                    } @else if (!searching && matchedCrmArticles?.length === 0) {
                        <div class="result text-center">
                            {{
                                fcCrmSearch.value?.length > 0 ? 'Bestekpost niet gevonden' : 'Voer een omschrijving in'
                            }}
                        </div>
                    }

                    @for (item of matchedCrmArticles; track item.id; let itemIndex = $index) {
                        <div
                            class="result d-flex justify-content-between align-items-center"
                            #crmArticleItem
                            [class.highlight]="itemIndex === selectedIndex"
                            [class.header-row]="!item.has_price"
                            (click)="selectBestekpost(item)">
                            <span>
                                {{ item.crm_article_id }}
                                @if (item.description) {
                                    <span class="text-muted"> - {{ item.description }}</span>
                                }
                            </span>

                            @if (item.price_per_unit) {
                                <span class="text-muted">{{ item.price_per_unit | currency: 'EUR' }}</span>
                            }
                        </div>
                    }
                </div>
            } @else if (!selectedGroupName) {
                <input #stepFocusInput [formControl]="fcArticleSearch" placeholder="Zoeken in groepen" />

                <div class="results">
                    @if (searching) {
                        <div class="result text-center">aan het zoeken...</div>
                    } @else if (!searching && matchedGroups?.length === 0) {
                        <div class="result text-center">
                            {{ fcArticleSearch.value?.length > 0 ? 'Groep niet gevonden' : 'Voer een omschrijving in' }}
                        </div>
                    }

                    @for (
                        group of matchedGroups;
                        track group.group + '_' + (group.items.length === 1 ? group.items[0].id : 'group');
                        let groupIndex = $index
                    ) {
                        <div
                            class="result font-weight-bold"
                            #groupItem
                            [class.highlight]="groupIndex === selectedIndex"
                            (click)="selectGroup(group.group, group.items.length === 1 ? group.items[0] : undefined)">
                            {{ group.group }}
                            @if (group.items?.length === 1) {
                                <span class="text-muted"> - {{ group.items[0].name }}</span>
                            }
                        </div>
                    }
                </div>
            } @else {
                <h1>
                    <button type="button" class="back-link" (click)="backToGroups()">
                        <mat-icon fontSet="fas" fontIcon="fa-chevron-left"></mat-icon>
                        {{ selectedGroupName }}
                    </button>
                </h1>

                <input #stepFocusInput [formControl]="fcArticleSearch" placeholder="Zoeken in markeringen" />

                <div class="results">
                    @if (searching) {
                        <div class="result text-center">aan het zoeken...</div>
                    } @else if (!searching && matchedGroupArticles?.length === 0) {
                        <div class="result text-center">
                            {{
                                fcArticleSearch.value?.length > 0
                                    ? 'Markering niet gevonden'
                                    : 'Voer een omschrijving in'
                            }}
                        </div>
                    }

                    @for (item of matchedGroupArticles; track item.id; let itemIndex = $index) {
                        <div
                            class="result"
                            #articleItem
                            [class.highlight]="itemIndex === selectedIndex"
                            (click)="selectArticle(item, selectedGroupName)">
                            {{ item.name }}
                        </div>
                    }
                </div>
            }
        </div>
    }

    @if (activeStep === STEPS.MATERIAL) {
        <div class="modal-inner-inner">
            <h1>
                Materiaal<small> ({{ article?.group }} - {{ article?.name }})</small>
            </h1>

            <div class="material-tabs">
                <button
                    type="button"
                    class="material-tab"
                    [class.active]="materialTab === 'planned'"
                    (click)="selectMaterialTab('planned')">
                    Gepland materiaal ({{ planningMaterials.length }})
                </button>
                <button
                    type="button"
                    class="material-tab"
                    [class.active]="materialTab === 'unplanned'"
                    (click)="selectMaterialTab('unplanned')">
                    Niet gepland materiaal
                </button>
            </div>

            <input #stepFocusInput [formControl]="fcMaterialSearch" placeholder="Zoeken in materialen" />

            <div class="results">
                @if (catalogLoading) {
                    <div class="result text-center">materialen laden...</div>
                } @else if (searching) {
                    <div class="result text-center">aan het zoeken...</div>
                } @else if (!searching && matchedMaterials?.length === 0) {
                    <div class="result text-center">
                        {{
                            fcMaterialSearch.value?.length > 0 ? 'Materiaal niet gevonden' : 'Voer een omschrijving in'
                        }}
                    </div>
                }

                @for (material of matchedMaterials; track material.id + '_' + material.partOfPlanning; let i = $index) {
                    @let width = material | materialProperty: 'width';
                    @let optionals = material | materialDetails: true;

                    <div
                        class="result d-flex justify-content-between align-items-center"
                        #materialItem
                        [class.highlight]="i == selectedIndex"
                        (click)="selectMaterial(material)">
                        <span class="name text-left">
                            <strong>
                                {{ material | materialProperty: 'name' }}
                                @if (Roles.Codalt | hasRole) {
                                    #{{ material.id }}
                                }</strong
                            >&nbsp;
                            @if (material.partOfPlanning && material.quantity != null) {
                                &nbsp;<small class="text-muted">({{ material.quantity | number: '0.0-2' }} kg)</small
                                >&nbsp;
                            }
                            &nbsp;<i class="text-muted">{{ material | materialProperty: 'usage' }}</i
                            >&nbsp;
                            @if (width) {
                                &nbsp;<small class="text-muted">({{ width }} cm)</small>&nbsp;
                            }
                            <br />

                            @for (
                                rawMaterial of material | nonMainRawMaterials;
                                track rawMaterial.id;
                                let isLast = $last
                            ) {
                                <small class="text-muted">
                                    {{ rawMaterial | materialProperty: 'typeName' : rawMaterial.material_type?.name
                                    }}{{ isLast ? '' : ',' }}
                                </small>
                            }
                        </span>

                        <span class="color text-right d-flex align-items-center">
                            {{ material | materialProperty: 'colorName' }}

                            @let colorName = material | materialProperty: 'colorName';
                            @let color = material | materialProperty: 'color';

                            @if (colorName) {
                                <span
                                    class="color-circle-small me-2"
                                    [class.transparent]="colorName === 'transparant'"
                                    [style.background]="color"></span>
                            } @else {
                                <span class="d-inline-block size-24"></span>
                            }

                            <strong>{{ material | materialProperty: 'colorRal' }}</strong>
                        </span>
                    </div>
                }
            </div>
        </div>
    }

    @if (activeStep === STEPS.OPTIONAL) {
        <div class="modal-inner-inner">
            <h1>
                Optionele materialen<br />
                <small>
                    @let colorName = material | materialProperty: 'colorName';

                    {{ material | materialProperty: 'name' }} - {{ material | materialProperty: 'colorName' }}&nbsp;

                    <span
                        class="color-circle-small me-2"
                        [class.transparent]="colorName === 'transparant'"
                        [style.background]="material | materialProperty: 'color'"></span>

                    <strong>{{ material | materialProperty: 'colorRal' }}</strong>
                    &nbsp;{{ material | materialProperty: 'usage' }}
                </small>
            </h1>

            @if (material?.partOfPlanning) {
                <div class="results">
                    <mat-selection-list #selectedOptionals>
                        @for (optional of matchedOptionals; track optional.id; let i = $index) {
                            <mat-list-option
                                class="result d-flex justify-content-between align-items-center"
                                [value]="optional"
                                [selected]="true"
                                [disabled]="optional?.optional !== true"
                                togglePosition="before">
                                <span class="name text-left">
                                    {{ optional | materialProperty: 'name' }}
                                    <small class="text-muted">
                                        {{ optional.pivot?.consumption ?? optional.consumption }}
                                        {{ optional.consumption_type?.name }}
                                    </small>
                                </span>

                                <small class="text-muted">
                                    @if (optional.material_type?.name !== optional.name) {
                                        {{ optional.material_type?.name }}
                                    }

                                    {{ optional?.optional !== true ? '(verplicht)' : '' }}
                                </small>

                                <span class="color text-right d-flex align-items-center">
                                    {{ optional | materialProperty: 'colorName' }}
                                </span>
                            </mat-list-option>
                        }
                    </mat-selection-list>
                </div>
            } @else {
                <div class="results">
                    @for (group of groupedOptionals; track group.materialType.id) {
                        <h4 class="optionals-group">{{ group.materialType.name }}</h4>

                        @if (group.materialType.single) {
                            <mat-radio-group
                                [value]="selectedOptionalsMap.get(group.materialType.id) ?? null"
                                (change)="selectedOptionalsMap.set(group.materialType.id, $event.value)"
                                (keyup.enter)="isOptionalSelectionValid() && selectGroupedOptionals()">
                                @if (group.optional) {
                                    <mat-radio-button
                                        [value]="null"
                                        (dblclick)="isOptionalSelectionValid() && selectGroupedOptionals()">
                                        <span>Geen</span>
                                    </mat-radio-button>
                                }
                                @for (raw of group.rawMaterials; track raw.id) {
                                    <mat-radio-button
                                        [value]="raw"
                                        (dblclick)="isOptionalSelectionValid() && selectGroupedOptionals()">
                                        <span>{{ raw.name }}</span>
                                        <small class="text-muted ms-1">{{ raw.supplier?.name }}</small>
                                        @if (raw.pivot?.consumption ?? raw.consumption) {
                                            <small class="text-muted ms-1">
                                                {{ raw.pivot?.consumption ?? raw.consumption }}
                                                {{ raw.consumption_type?.name }}
                                            </small>
                                        }
                                    </mat-radio-button>
                                }
                            </mat-radio-group>
                        } @else {
                            @for (raw of group.rawMaterials; track raw.id) {
                                <div class="optional-checkbox-row">
                                    <mat-checkbox
                                        [checked]="isSelectedCheckbox(group.materialType.id, raw)"
                                        (change)="toggleCheckbox(group.materialType.id, raw)">
                                        <span>{{ raw.name }}</span>
                                        @if (raw.material_type?.name !== raw.name) {
                                            <small class="text-muted ms-1">{{ raw.material_type?.name }}</small>
                                        }
                                        <small class="text-muted ms-1">{{ raw.supplier?.name }}</small>
                                        @if (raw.pivot?.consumption ?? raw.consumption) {
                                            <small class="text-muted ms-1">
                                                {{ raw.pivot?.consumption ?? raw.consumption }}
                                                {{ raw.consumption_type?.name }}
                                            </small>
                                        }
                                    </mat-checkbox>
                                </div>
                            }
                        }
                    }
                </div>
            }
        </div>
    }

    @if (activeStep === STEPS.AMOUNT) {
        <div class="modal-inner-inner">
            <h1>
                Productie
                @if (pickerMode === 'bestekpost') {
                    <strong>{{ articleCrm?.description ?? articleCrm?.crm_article_id }}</strong>
                } @else {
                    <strong>{{ article?.group }} - {{ article?.name }}</strong>
                }
                <br />
            </h1>

            <div class="amount d-flex flex-column gap-3 justify-content-center align-items-center w-100 mb-3">
                <mat-form-field class="w-75" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>
                        {{ pickerMode === 'bestekpost' ? articleCrm?.unit : article?.article_unit_type?.name }}
                    </mat-label>

                    <input
                        #stepFocusInput
                        [formControl]="fcAmount"
                        (keydown.enter)="add()"
                        type="number"
                        step="0.01"
                        matInput />
                </mat-form-field>
            </div>
        </div>
    }

    <div class="buttons">
        @if (activeStep === STEPS.OPTIONAL) {
            @if (material?.partOfPlanning) {
                <button class="planning-button confirm" (click)="selectOptional()" mat-raised-button color="primary">
                    Volgende
                </button>
            } @else {
                <button
                    class="planning-button confirm"
                    [disabled]="!isOptionalSelectionValid()"
                    (click)="selectGroupedOptionals()"
                    mat-raised-button
                    color="primary">
                    Volgende
                </button>
            }
        } @else if (activeStep === STEPS.LOCATION) {
            <button
                class="planning-button confirm"
                (click)="selectLocation(fcLocation.value)"
                mat-raised-button
                color="primary">
                Volgende
            </button>
        } @else {
            @let disabled = !fcAmount.value || fcAmount.value <= 0;

            <button
                class="planning-button confirm"
                [disabled]="disabled"
                (click)="add()"
                mat-raised-button
                color="primary">
                Toevoegen
            </button>
        }

        <button class="planning-button cancel" mat-raised-button mat-dialog-close="">Annuleren</button>
    </div>
</div>
